/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Leagues_TitleInputs */



/**
* | output |
* | --- |
* | "Leagues" |
*
* @param {Leagues_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const leagues_title = /** @type {((inputs?: Leagues_TitleInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Leagues_TitleInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Ligues")
	if (locale === "es") return /** @type {LocalizedString} */ ("Ligas")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Ligas")
	if (locale === "it") return /** @type {LocalizedString} */ ("Campionati")
	return /** @type {LocalizedString} */ ("Leagues")
});